
<div mat-dialog-title>Import Cash Settings<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  @if (hasFile && !isValidFile) {
    <mat-card class="error block">
      <mat-card-title class="error">{{invalidFileErrorHeader}}</mat-card-title>
      <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;" >{{invalidFileErrorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  @if (errorMessage) {
    <mat-card class="error block">
      <mat-card-title class="error">An error occurred.</mat-card-title>
      <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;">{{errorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  <div>When importing account cash settings, if a set-aside amount is present but the date is blank, the amount will be uploaded using today's date.</div>
  <div>If there already is a set-aside amount on the account which matches the set-aside date listed on the import file, the set-aside amount for that date will be overwritten with the value in the file.</div>
  <div>
    <table class="import" width="100%">
      <tr>
        <th align="left" style="vertical-align: top;"><label>File name</label></th>
        <td>
          <div class="bottomPaddingElementDialog">
            <irb-file-selector (change)="onFileChange($event)"></irb-file-selector>
            <div>File type must be .csv</div>
          </div>
        </td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Instructions</label></th>
        <td><div class="block">Your selected file must be in .csv format and follow iRebal's format, which is: Account No, Cash Minimum, Cash Target, Cash Maximum, Min/Target/Max % or $, Set Aside Cash Amount, Set Aside % or $, Set Aside date</div></td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Template</label></th>
        <td>
          <div>Use our .csv template to prepare your file.<br/>
            @if (isSetAsideCashEnabled && isDistHoldCashEnabled) {
              <a href="/assets/template/Accounts-Setaside.xlsx">Download template: Accounts.xlsx</a>
            } @else if (isSetAsideCashEnabled && !isDistHoldCashEnabled) {
              <a href="/assets/template/alt/Accounts-Setaside.xlsx">Download template: Accounts.xlsx</a>
            } @else if (!isSetAsideCashEnabled && isDistHoldCashEnabled) {
              <a href="/assets/template/Accounts.xlsx">Download template: Accounts.xlsx</a>
            } @else {
              <a href="/assets/template/alt/Accounts.xlsx">Download template: Accounts.xlsx</a>
            }
          </div>
          </td>
        </tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="submitFile()" [disabled]="!(hasFile && isValidFile)" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>
